import { Component, inject } from '@angular/core';
import { takeUntil, tap } from 'rxjs';
import {
  CustomResult,
  CustomResultOfGetOrganizationLandingPageDto,
  GetReadyTemplatesWithPaginationDto,
} from 'src/app/core/api/models';
import { LandingPagesService } from 'src/app/core/api/services';
import { ApiNotificationService } from 'src/app/core/services/api-notification.service';
import { ConsoleService } from 'src/app/core/services/console.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { AppDomService } from 'src/app/core/services/dom.service';
import { BasePageComponent } from '../../shared/base';
import { ReadyTemplatesModalComponent } from './ready-templates/ready-template-modal/ready-template-modal.component';
import { ReadyTemplatesSaveModalComponent } from './ready-templates/ready-template-save-modal/ready-template-save-modal.component';

@Component({
  selector: 'app-content-management-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
  standalone: false,
})
export class LandingPageFormComponent extends BasePageComponent {
  //#region properties
  apiNotificationService = inject(ApiNotificationService);
  dialogService = inject(DialogService);
  landingPageService = inject(LandingPagesService);

  pageHtml: string;
  jsCode: string = '';
  cssCode: string = '';
  editorCssCode: string = '';
  htmlCode: string = '';
  shortUrl: string = '';
  //#endregion

  ngOnInit(): void {
    this.pageVocabs = 'pages.landingPage.';
    this.getOrganizationLandingPageApi();
  }

  //#region api
  getOrganizationLandingPageApi() {
    this.landingPageService
      .landingPagesGetOrganizationLandingPage()
      .pipe(this.basePipeOperators())
      .subscribe((res: CustomResultOfGetOrganizationLandingPageDto) => {
        this.pageHtml = res.data.pageHtml;
        this.jsCode = res.data.pageJs;
        this.cssCode = res.data.pageSass;
        this.shortUrl = res.data.shortUrl;
        //#region create short link
        // if (this.shortUrl == '' || this.shortUrl == null) {
        //   this.landingPageService
        //     .landingPagesCreateOrganizationPr53Url()
        //     .pipe(this.basePipeOperators())
        //     .subscribe((result: CustomResult) => {
        //       if (result.isSucceed) {
        //         var pos = result.message.indexOf('https://');
        //         var link = result.message.slice(pos);
        //         this.shortUrl = link;
        //       }
        //     });
        // }
        //#endregion
      });
  }

  createOrUpdateLandingPageApi(html) {
    this.landingPageService
      .landingPagesCreateOrUpdate({
        body: {
          landingPreview: '',
          pageHtml: html,
          pageJs: this.jsCode,
          pageSass: this.cssCode,
        },
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  getReadyTemplatesApi() {
    const modalResult = this.dialogService.openModal({
      component: ReadyTemplatesModalComponent,
    });

    const sub = modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((res: GetReadyTemplatesWithPaginationDto) => {
        this.pageHtml = res?.templateHtml;
        this.jsCode = res?.templateJs;
        this.cssCode = res?.templateSass;
      });
  }

  //#endregion
  openTemplateSelectorDialog() {
    this.getReadyTemplatesApi();
  }

  showReadyTemplateSaveDialog() {
    let data = {
      htmlCode: this.htmlCode,
      jsCode: this.jsCode,
      cssCode: this.cssCode,
      editorCssCode: this.editorCssCode,
    };
    const modalResult = this.dialogService.openModal({
      component: ReadyTemplatesSaveModalComponent,
      data: data,
    });

    const sub = modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe();
  }

  baseObserver = {
    next: (result: CustomResult) => {
      this.apiNotificationService.notifyMessage({ result });
    },
    error: (error) => {
      ConsoleService.error('error', error);
    },
    complete: () => (this.pageConfig.loading = false),
  };

  createOrUpdateLandingPage() {
    this.loading = true;
    let mainCss =
      'body{ direction: rtl !important;font-family: "Vazirmatn" !important; }';
    if (!this.cssCode.includes(mainCss)) {
      this.cssCode += mainCss;
    }

    let htmlString = `<html><head><link href="/assets/fonts/Vazirmatn/Vazirmatn-font-face.css" rel="stylesheet"><style>${this.cssCode} ${this.editorCssCode}</style></head>${this.htmlCode}<script>${this.jsCode}</script></html>`;
    htmlString = htmlString.replace(/[\n\r]/g, '');
    htmlString = htmlString.replace(/"/g, "'");
    this.createOrUpdateLandingPageApi(htmlString);
  }

  setViewSize(size: string): void {
    switch (size) {
      case 'mobile':
        document
          .getElementsByClassName('gjs-frame')[0]
          .setAttribute('style', 'width: 375px !important');
        break;
      case 'tablet':
        document
          .getElementsByClassName('gjs-frame')[0]
          .setAttribute('style', 'width: 768px !important');
        break;
      case 'desktop':
        document
          .getElementsByClassName('gjs-frame')[0]
          .setAttribute('style', 'width: 100% !important');
        break;
    }
  }

  openLandingPagePreview() {
    window.open(
      'https://smsadmin.pishgamrayan.com/landing-page/' +
        this.currentUserInfo?.organizationName,
      '_blank',
      'width=800,height=600'
    );
  }
}
